import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import NewSideBar from "../../component/mainAdminComponents/newSideBar";
import AppDropDown from "../../component/regStdData/dropDown";
import { useHistory } from "react-router-dom";
import Header from "../../component/mainAdmin/Header";
import styles from "../../component/mainAdmin/allassignments.module.css";
import { filterquiz, getadminquiz } from "../../Redux/action/adminquiz";

const Quizdetails = () => {

    const dispatch = useDispatch()

  const [states, setStates] = useState({
    courseName: "",
    topicName: "",
    batchNo: "",
    classTime: "",
  });



  
  useEffect(() => {
      
      dispatch(getadminquiz());
      
    }, []);
    
    const { loading,error,data,filtereddata} = useSelector((state) => state.getadminquizresults);
  
    console.log(data)

  return (
    <>
      <Header />
      <div className="mainDashBox">
        <div className="sideBOxhai">
          <NewSideBar className="sideContainer" />
        </div>

        <div className={styles.maindiv}>
          <div className={styles.header}>
          <div>
                <AppDropDown
                  labelName="CourseName"
                
                  propsArr={
                    data?.length != 0
                      ? Array.from(
                          new Set(
                            data?.map((a) => {
                              return a.courseName;
                            })
                          )
                        )
                      : []
                  }
                  onChange={(e) => {
                    setStates({
                      ...states,
                      courseName: e.target.value,
                      topicName: e.target.value == "" ? "" : states.topicName,
                    });
                  }}
                />
                
              </div>
              <div>
                <AppDropDown
                  labelName="Topic Name"
                  
                  propsArr={Array.from(
                    new Set(
                      data?.filter((name) => {
                          return (
                            name.courseName
                            //   .indexOf(states.courseName.toLowerCase()) >= 0
                          );
                        })
                        .map((filteredName, i) => {
                          return states.courseName ? filteredName.topicName : null;
                        })
                    )
                  )}
                  onChange={(e) => {
                    setStates({
                      ...states,
                      topicName: e.target.value,
                      batchNo: e.target.value == "" ? "" : states.batchNo,
                    });
                  }}
                />
                
              </div>
              <div>
                <AppDropDown
                  labelName="Batch No"
                  propsArr={Array.from(
                    new Set(
                      data?.filter((name) => {
                          return (
                            name.topicName
                            //   .toLowerCase()
                            //   .indexOf(states.topicName.toLowerCase()) >= 0
                          );
                        })
                        .map((filteredName, i) => {
                          return states.topicName && states.courseName ? filteredName.batchNo : null;
                        })
                    )
                  )}
                  onChange={(e) => {
                    setStates({
                      ...states,
                      batchNo: e.target.value,
                    });

                  }}
                />
                
              </div>
              <div>
                <AppDropDown
                  labelName="Class Time"
                  propsArr={Array.from(
                    new Set(
                      data?.filter((name) => {
                          return (
                            name.batchNo
                            //   .toLowerCase()
                            //   .indexOf(states.batchNo.toLowerCase()) >= 0
                          );
                        })
                        .map((filteredName, i) => {
                          return states.batchNo && states.topicName ? filteredName.classTime : null;
                        })
                    )
                  )}
                  onChange={(e) => {
                    setStates({
                      ...states,
                      classTime: e.target.value,
                    });
                  }}
                />
                
              </div>
              
              <div className={styles.btndiv}>
                <button onClick={() => dispatch(filterquiz(states.courseName,states.topicName,states.batchNo,states.classTime))}>Check</button>
                <button>Reset</button>
              </div>
          </div>
          <div className={styles.infodiv}>
             
             <div className={styles.greendivquiz}>
                <div>
               <h6>student name</h6>
               </div>
                <div>
               <h6>email</h6>
               </div>
                <div>
               <h6>grade</h6>
               </div>
                <div>
               <h6>Percentage</h6>
               </div>
                <div>
               <h6>ID</h6>
               </div>
              
             </div>
             {loading && (
               <div style={{width:'100%',display:'flex',alignItems:'center',justifyContent:'center',height:'80vh'}}>
               <div className="spinner-border" role="status">
                 {/* <span className="visually-hidden"></span> */}
               </div>
               </div>

             )}
             {!loading && filtereddata?.length === 0 ? data?.map((e, i) => {
                     console.log(e);
                     return (
                       <div className={styles.whitediv} key={i}>
                         <div>
                           <h6>{e.name}</h6>
                         </div>
                         <div>
                           <h6>{e.email}</h6>
                         </div>
                         <div>
                           <h6>{e.grade}</h6>
                         </div>
                         <div>
                           <h6>{e.perc}</h6>
                         </div>
                         <div>
                           <h6>{e.stdId}</h6>
                         </div>
                          
                        
                       </div>
                     );
             }) : (
                filtereddata?.length > 0 && filtereddata?.map((e, i) => {
                    console.log(e);
                    return (
                      <div className={styles.whitediv} key={i}>
                        <div>
                          <h6>{e.name}</h6>
                        </div>
                        <div>
                          <h6>{e.email}</h6>
                        </div>
                        <div>
                          <h6>{e.grade}</h6>
                        </div>
                        <div>
                          <h6>{e.perc}</h6>
                        </div>
                        <div>
                          <h6>{e.stdId}</h6>
                        </div>
                         
                       
                      </div>
                    );
            })
             )}
             


              
           </div>
        </div>
        
      </div>
      
    </>
  );
};

  //    }) : filteredassignment.map((e, i) => {
                //      console.log(e);
                //      return (
                //        <div className={styles.whitediv}>
                //          <div>
                //            <h6>{e.assignmentName}</h6>
                //          </div>
                //          <div>
                //            <h6>{e.assignmentDate.slice(0, 16)}</h6>
                //          </div>
                //          <div>
                //            <h6>{e.deadline.slice(0, 12)}</h6>
                //          </div>
                //          <div>
                //            <FaEye onClick={() => openmodal(e._id)} />
                //          </div>
                //        </div>
                //      );
                //    })}
             {/* {
               (adminassignment &&
                 (states.city === "" || states.city === "Select Option") &&
                 (states.course === "" || states.course === "Select Option") &&
                 (states.institute === "" ||
                   states.institute === "Select Option") &&
                 (states.batch === "" || states.batch === "Select Option") &&
                 (states.time === "" || states.time === "Select Option") &&
                   )

               // (states.city === ""
               //       ? adminassignment.map((e, i) => {
               //         console.log(e)
               //           return (
               //             <div className={styles.whitediv}>
               //               <div>
               //                 <h6>{e.assignmentName}</h6>
               //               </div>
               //               <div>
               //                 <h6>{e.assignmentDate.slice(0, 16)}</h6>
               //               </div>
               //               <div>
               //                 <h6>{e.deadline.slice(0, 12)}</h6>
               //               </div>
               //               <div>
               //                 <FaEye onClick={() => openmodal(e._id)} />
               //               </div>
               //             </div>
               //           );
               //         })
               //       : adminassignment.filter(
               //           (entry) =>
               //             entry.city === states.city &&
               //             entry.institute === states.institute &&
               //             entry.course === states.course &&
               //             entry.batch === states.batch &&
               //             entry.time === states.time
               //         )).map((k) => {
               //           return <div className={styles.whitediv}>
               //           <div>
               //             <h6>{k?.assignmentName}</h6>
               //           </div>
               //           <div>
               //             <h6>{k?.assignmentDate?.slice(0,16)}</h6>
               //           </div>
               //           <div>
               //             <h6>{k?.deadline}</h6>
               //           </div>
               //           <div>
               //             <FaEye onClick={() => openmodal(k?._id)} />
               //           </div>
               //         </div>
               //         } )
             }

             {adminassignment && (
               (states.city !== '' || states.city !== 'Select Option') && (
                 adminassignment.filter(
                             (entry) =>
                               entry.city === states.city &&
                               entry.institute === states.institute &&
                               entry.course === states.course &&
                               entry.batch === states.batch &&
                               entry.time === states.time
                           )).map((k) => {
                             return <div className={styles.whitediv}>
                             <div>
                               <h6>{k?.assignmentName}</h6>
                             </div>
                             <div>
                               <h6>{k?.assignmentDate?.slice(0,16)}</h6>
                             </div>
                             <div>
                               <h6>{k?.deadline?.slice(0,12)}</h6>
                             </div>
                             <div>
                               <FaEye onClick={() => openmodal(k?._id)} />
                             </div>
                           </div>
                           } )
             )} */}

export default Quizdetails;
